export const aleksandraTrzcinska = {
    'mydrId': 'aleksandratrzcinska',
    'firstName': 'Aleksandra',
    'lastName': 'Trzcińska',
    'profession': 'Psycholog, psychoterapeuta młodzieży i dorosłych',
    'avatar': 'aleksandra-trzcinska.webp',
    'slug': 'psycholog-aleksandra-trzcinska',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'children'],
        ['psychoterapy', 'adult']
    ]
}